/* template */
<template><div><div :class="({    'at-didao': atDidao,    'is-android': isAndroid,    'is-harmonyos': isHarmonyos,})"><title-bar bg-color="#ffffff" icon-color="#333333" title-color="#333333" :title="($t('city.title'))" :is-show-right-set="(false)" :isHideNav="(isHideNav)" @backClick="onBackClick" @nativeHidden="nativeHidden" ref="titleBar" class="custom-title-bar"/></div><select-city :city-list="(citiesList)" :style="(cityStyle)" :current-city="(cityName)" :at-didao="(atDidao)" :title-bar-height="(titleBarHeight)" is-new-version @changeCity="changeCity"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4d9fb10e"}'>
  .custom-title-bar
    position relative
    z-index 9
  .is-harmonyos
    .custom-title-bar
      position fixed
      top 0
      left 0
      z-index 9
    .city-box
      position fixed
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

  import mpx, { createPage } from '@mpxjs/core'
  import { is, build } from '@didi/webx-js'

  import { hideNativeBar } from '../../lib/js/util'
  import { getErrorMessage } from '../../lib/webx/utils/error'
  import { rpx } from '../../lib/webx/utils/format'

  import { GlobalEnv, setTitle } from '../../lib/webx' // 从lib中引入ClobalEnv
  import { initEnv } from '../../lib/webx/global_env'

  import { getCommonCitiesList } from '../../api'

  createPage({
    async onLoad() {
      window.PerfTrack?.jsReady?.()
      await initEnv({ needLocation: true })
      setTitle(this.$t('city.title'))
      this.currentCityId = GlobalEnv.locationInfo.cityId
      mpx.showLoading()
      await this.getCityList()
      mpx.hideLoading()
      document.getElementById('loading') &&
        (document.getElementById('loading').style.display = 'none')
    },
    data: {
      citiesList: [],
      currentCityId: 1,
      atDidao: GlobalEnv.atDidao,
      isAndroid: is('android'),
      isHarmonyos: is('harmonyos'),
      titleBarHeight: 0,
    },
    computed: {
      cityName() {
        if (this.citiesList.length) {
          const cities = this.citiesList.reduce(
            (prev, group) => prev.concat(group.cities),
            []
          )
          return (
            cities.find(city => `${city.id}` === `${this.currentCityId}`)?.name ||
            ''
          )
        } else {
          return ''
        }
      },
      isHideNav() {
        return hideNativeBar()
      },
      cityStyle() {
        if (!this.isHarmonyos) {
          return {}
        }
        return {
          top: rpx(`${this.titleBarHeight * 2}rpx`),
        }
      },
    },
    methods: {
      changeCity({ detail: { cityId } }) {
        GlobalEnv.locationInfo.cityId = cityId
        // 更新当前城市,并跳转到上个页面
        mpx.navigateBack({
          success: () => {
            setTimeout(() => {
              const currUrl = window.location.href
              const newUrl = build(currUrl, {
                cityId,
                city_id: cityId,
                cityid: cityId,
              })
              window.history.replaceState(
                window.history.state,
                document.title,
                newUrl
              )
            }, 200)
          },
        })
      },
      nativeHidden(e) {
        this.titleBarHeight = e?.detail?.safeAreaInsetTop
      },
      onBackClick() {
        mpx.navigateBack()
      },
      async getCityList() {
        try {
          const lang = GlobalEnv.lang
          const source_id = GlobalEnv.channelId
          const res = await getCommonCitiesList({
            lang,
            source_id,
          })
          if (res.errno === 0) {
            const data = res.data.groups
            this.citiesList = data.map(group => {
              const cities = group.cities.map(city => ({
                ...city,
                id: city.cityid,
                en:
                  city.tags && typeof city.tags === 'string'
                    ? city.tags.split(',')[0] || ''
                    : '',
              }))
              return {
                id: group.name.toUpperCase(),
                letter: group.name.toUpperCase(),
                cities,
              }
            })
          } else {
            mpx.showModal({
              content: res.errmsg,
              title: '错误',
            })
          }
        } catch (error) {
          mpx.showModal({
            content: getErrorMessage({
              message: 'jsError',
            }),
            title: '错误',
          })
        }
      },
    },
  })


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"backgroundColor":"#ffffff"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'select-city':getComponent(require("../../components/select-city/index.mpx?component=true&componentId=indexdd660a10")),'title-bar':getComponent(require("../../../node_modules/@didi/wyc-components/src/components/title-bar/index.mpx?component=true&componentId=index461bd906"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
